import {
  useMutation,
} from '@tanstack/react-query'
import api  from '../../services/api';


export const useLoginMutation = () => {

  return useMutation({
    mutationFn: async (body) => {
      const res = await api.post("/auth/login", body, { timeout: 30000 });
      return res.data;
    }
  });
};